import { getStoreId } from "$/hooks/use-store-information"
import tireStorageQueries from "$/lib/queries/tire-storage-queries"
import { requireNonFreeTier } from "$/lib/require-non-free-tier"
import { formatTireStorageId } from "@repo/common"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { z } from "zod"

const paramsSchema = z.object({
  tireStorageId: z.string().uuid(),
})

export const Route = createFileRoute("/(app)/_auth/tire-hotel/$tireStorageId")({
  params: {
    parse: (params) => paramsSchema.parse(params),
    stringify: ({ tireStorageId }) => ({ tireStorageId: `${tireStorageId}` }),
  },
  loader: async ({ context: { queryClient }, params }) => {
    await requireNonFreeTier(queryClient)
    const storeId = await getStoreId()
    if (!storeId) throw redirect({ to: "/tire-hotel" })
    const tireStorage = await queryClient.ensureQueryData(
      tireStorageQueries.detail(storeId, params.tireStorageId),
    )
    return { crumb: formatTireStorageId(tireStorage.displayNumber) }
  },
})
